import React, { createContext, useContext, useMemo, useState } from 'react';

type ModalContextType = {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ModalContext = createContext<ModalContextType>(undefined as any);

export const useModalContext = () => {
  return useContext(ModalContext);
};

export const ModalContextProvider = ({ children }: any) => {
  const [visible, setVisible] = useState(false);

  const context = useMemo(() => {
    return {
      visible,
      setVisible,
    };
  }, [visible]);

  return <ModalContext.Provider value={context}>{children}</ModalContext.Provider>;
};
